var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "event-chart" },
    [
      _c("div", { staticClass: "event-info" }, [
        _c("div", { staticClass: "event-name" }, [
          _vm._v(_vm._s(_vm.eventItem.eventName))
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "event-date" }, [
          _vm._v("Event Date: " + _vm._s(_vm.eventItem.prefDate))
        ])
      ]),
      _vm._v(" "),
      _c("EventChart", {
        attrs: {
          labels: _vm.chartData.labels,
          data: _vm.chartData.data,
          expectedValue: _vm.chartData.expectedValue,
          startDate: _vm.chartData.startDate,
          endDate: _vm.chartData.endDate,
          width: 254,
          height: 200
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-94099b20", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-94099b20","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/eventManagement/reports/EventChart.vue
// module id = 2007
// module chunks = 1